<mat-icon
    *ngIf="enableSpinner$ | async"
    class="align-page-center"
    style="z-index: 999999"
>
    <mat-spinner
        strokeWidth="3"
        style="z-index: 999999"
        [diameter]="40"
        class="spinner-center"
    >
    </mat-spinner>
</mat-icon>
<div class="uploadImagesDialog">
    <div class="dialogHeader">
        <div class="headerDetails">
            <h2 mat-dialog-title class="headerTitle">Add Set Image</h2>
            <span class="headerDescription"
                >Add images to Set of
                {{
                    sumOfQuantity(variantImageModalData.currentVariantIndex)
                }}</span
            >
        </div>
        <div class="closeButton">
            <mat-icon (click)="close()">close</mat-icon>
        </div>
    </div>

    <hr />

    <div
        *ngIf="inputImages.length == 0"
        class="content"
        mat-dialog-content
        #uploadzone
        dropzone
        [class.hovering]="uploadzone.isHovering"
        (hovered)="uploadzone.isHovering = $event"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
    >
        <div class="contentDetails">
            <div class="uploadIcon">
                <img src="/assets/icons/cloud_upload_24px.svg" alt="" />
            </div>
            <div class="uploadImages">
                Drag and drop images or
                <input type="file" id="file" class="file-input" (click)="onClick($event)">
                <label style="cursor: pointer;" class="selectImages" for="file">Select Images</label>
            </div>
            <div class="imageTypes">
                <span>Accepts .jpg, .png files (up to 5mb)</span>
            </div>
        </div>
    </div>

    <div
        *ngIf="inputImages.length > 0"
        class="selectedFilesContainer"
        style="margin-top: 20px"
    >
        <div
            class="selectedFiles"
            *ngFor="let image of inputImages; let imageIndex = index"
        >
            <!-- <mat-icon class="imageLogo">photo</mat-icon> -->
            <img class="imageLogo" src="/assets/icons/image_24px.png" alt="" />
            <div class="progressBar">
                <p class="fileName">
                    {{ image.file.name }}
                </p>
                <mat-progress-bar [value]="image.progress"></mat-progress-bar>
                <p class="progressPercentage">Uploaded {{ image.progress }}%</p>
            </div>
            <a
                class="deleteButton"
                title="Cancel"
                (click)="deleteFile(imageIndex)"
            >
                <img
                    class="deleteButton"
                    src="/assets/icons/delete_outline_24px.svg"
            /></a>
        </div>
    </div>

    <div class="actions" mat-dialog-actions>
        <button
            [ngClass]="
                onGoingRequestsCnt > 0 || inputImages.length === 0
                    ? 'uploadImagesButton'
                    : 'uploadImagesButton1'
            "
            [disabled]="onGoingRequestsCnt > 0 || inputImages.length === 0"
            (click)="uploadImages()"
        >
            Upload Images
        </button>
    </div>

    <input
        type="file"
        id="fileUpload"
        name="fileUpload"
        multiple="multiple"
        accept="image/*"
        style="display: none"
    />
</div>
